var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIModifyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88505 16.2801L5.61139 16.7083C5.26978 16.7722 4.96393 16.488 5.00345 16.1427L5.28107 13.7118C5.31683 13.3985 5.458 13.1067 5.68009 12.8846L15.2042 3.29997C15.6042 2.90001 16.2516 2.90001 16.6516 3.29997L18.1762 4.82453C18.5761 5.22449 18.5761 5.87196 18.1762 6.27192L8.61251 15.8952C8.41394 16.0937 8.16079 16.2283 7.88505 16.2801Z",
    fill: "#3284FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6493 16.8047H10.7539V15.3047H20.6493V16.8047Z",
    fill: "#3284FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIModifyOn);
export default __webpack_public_path__ + "static/media/i_modify_on.4b084b01e4a563cc4b829ffa4d6dad4d.svg";
export { ForwardRef as ReactComponent };